const createQuery = () => `
  ... on CompanyArticlesWidget {
    id
    companyArticles {
      type
      articles {
        _id
        headline
        fullUrlPath
        eventId
        eventBaseSlug
        eventArticleCategoryKey
        featured
        quote
        category
        contentType
        subContentType
        tags {
          tag
        }
        attribution
        subAttribution
        sell
        images {
          thumbnail_landscape_322 {
            url
          }
          thumbnail_portrait_286 {
            url
          }
          thumbnail_widescreen_553 {
            url
          }
        }
        address
        startDate
        postEventLink
        subAttribution
      }
    }
  }
`

export default createQuery
